export enum PriorityEnum {
  ALTA = '3',
  MEDIA = '2',
  BAIXA = '1',
}
